import React, { memo } from 'react';
import { convertToRubles } from 'app/selectors/Helpers';
import WidgetOverlay from 'app/containers/WidgetOverlayContainer';
import { IPreparedDailySeance, SeanceDisplaySettings } from 'app/types/common';
import cn from 'classnames';

type Props = {
	seanceData: IPreparedDailySeance,
	seanceDisplaySettings: SeanceDisplaySettings,
	currencySymbol: string,
	isMonitor: boolean,
};

const DailySeanceItemComponent = memo(({
	seanceData: {
		id: seanceId,
		cinema_id: cinemaId,
		release_id: releaseId,
		rambler_id: ramblerReleaseId,
		start_date_time: startTime,
		age_rating: ageRating,
		title: seanceTitle,
		price: seancePrice,
		hall,
		formats,
		genres,
		free_places_count,
	},
	seanceDisplaySettings: {
		format: isSettingsFormat,
		hall: isSettingsHall,
		price: isSettingsPrice,
	},
	currencySymbol,
}: Props) => {
	// TODO: исправить после НГ
	const isSoldOut = [1803].some(item => item === cinemaId)
		? free_places_count !== null && free_places_count === 0
		: false;
	const renderTitles = (titlesArr) => (
		titlesArr.map(({id, title}) => (
			<span key={id}>{title}</span>
		))
	);

	const renderPrice = (price) => {
		const doPricesNotMatch = price.min !== price.max;

		return (
			<span>
				{convertToRubles(price.min)} {currencySymbol}
				{doPricesNotMatch && ` - ${convertToRubles(price.max)} ${currencySymbol}`}
			</span>
		);
	};

	return (
		<div className={cn('daily-seance-item', {'daily-seance-item--disabled': isSoldOut})}>
			<WidgetOverlay
				cinemaId={cinemaId}
				releaseId={releaseId}
				seanceId={seanceId}
				startTime={startTime}
				ramblerReleaseId={ramblerReleaseId}
				page="seances"
				isSoldOut={isSoldOut}
			/>
			{isSoldOut ? <span className="seance-tooltip" data-tooltip={i18n.t("NoAvailableAeats")}>
				{i18n.t('NoAvailableAeats')}
			</span> : null}
			<div className="daily-seance-item__seance-time">
				{startTime && moment.parseZone(startTime).format('HH:mm')}
			</div>
			<div className="daily-seance-item__seance-info">
				<div className="daily-seance-item__seance-title">{seanceTitle}</div>
				<div className="daily-seance-item__genres-age-info">
					<span>{ageRating}</span>
					{genres && renderTitles(genres)}
				</div>
				<div className="daily-seance-item__other-info">
					{formats && isSettingsFormat && renderTitles(formats)}
					{seancePrice && isSettingsPrice && renderPrice(seancePrice)}
					{hall && isSettingsHall && <span>{i18n.t('Hall')} {hall.title}</span>}
				</div>
			</div>
		</div>
	);
});

export default DailySeanceItemComponent;
